<template>
  <el-cascader
    v-model="c"
    :props="props"
    :size="size"
    :disabled="disabled"
    style="width:230px"
    clearable
    :placeholder="placeholder"
    :checkStrictly="true"
    @blur="handleBlur"
    @change="handleChange"
  ></el-cascader>
</template>

<script>
import { Cascader } from 'element-ui'
// 异步省市区面板
export default {
  components: {
    ElCascader: Cascader
  },
  props: {
    value: Array, // vmodel值
    disabled: Boolean,
    placeholder: String, // 异步的数据，初始化的时候给下拼接的值，如：北京/北京市/朝阳区
    size: String
  },
  data() {
    return {
      options3: [],
      areaList: [],
      props: {
        value: 'id',
        children: 'children',
        label: 'name',
        lazy: true,
        lazyLoad: async(val, resolve) => {
          const length = val.level
          switch (length) {
            case 0:
              this.$store.dispatch('getProvinceList', 156).then((data) => {
                resolve(data)
              })
              break
            case 1:
              this.$store.dispatch('getCityList', Number(val.value)).then((data) => {
                resolve(data)
              })
              break
            case 2:
              this.$store.dispatch('getDistrict', Number(val.value)).then((data) => {
                const nodes = data.map((item) => ({
                  ...item,
                  leaf: true
                }))
                resolve(nodes)
              })
              break
            default:
              resolve([])
              break
          }
        }
      }
    }
  },
  computed: {
    c: {
      get() {
        return this.value.map(item => Number(item))
      },
      set(c) {
        this.$emit('input', c)
      }
    },

    options2() {
      return this.$store.state.areaList
    }
  },

  methods: {
    /**
     */
    async init() {
      await this.$store.dispatch('getProvinceList', 156)
      this.value[0] && (await this.$store.dispatch('getCityList', Number(this.value[0])))
      this.value[1] && (await this.$store.dispatch('getDistrict', Number(this.value[1])))
    },
    /**
     * 异步请求数据，这个版本的 el-cascader 没有lazyLoad
     */
    async handleItemChange(val, resolve) {
      console.log('val', val)
      const length = val.length
      switch (length) {
        case 1:
          await this.$store.dispatch('getCityList', Number(val[0]))
          resolve()
          break
        case 2:
          await this.$store.dispatch('getDistrict', Number(val[1]))
          resolve()
          break
      }
    },
    handleBlur() {
      this.$emit('blur', this.c)
    },
    handleChange(val) {
      this.$emit('change', val)
    }
  },

  async mounted() {
    // await this.init()
    // this.options3 = this.$store.state.areaList
  }
}
</script>
